import Keycloak from './keycloak-js';

const keycloak = new Keycloak({
  clientId: process.env.REACT_APP_REDHAT_CLIENTID,
  url: process.env.REACT_APP_REDHAT_URL,
  realm: process.env.REACT_APP_REDHAT_REALM,
  scope: process.env.REACT_APP_REDHAT_SCOPE,
  redirectUri: `${window.location.origin}/hospiadmission/`
});

export default keycloak;
